define(["jquery", "common/lib/forms/jquery.validate"], function($) {

	$.validator.addMethod("uniqEmail", function(value, element) {
	    var result = false;

        var originalEmail = $(element).data("original-email");
        if(originalEmail && originalEmail == value) {
            return true; // for Email & Password widget
        }

	    $.ajax({
	        contentType: "application/json",
	        url: "/validateEmail.action",
	        type: "POST",
	        async: false,
	        data: JSON.stringify({
	            email: value
	        }),
	        success: function(data) {
                result = !data.errorMessage;
	        }
	    });

	    return result;
	}, "An account with that email address already exists.");

    $.validator.addMethod("validPassword", function(value, element) {
        return /^\w*$/m.test(value);

    }, "This password contains invalid characters. Only letters and numbers are allowed.");

    $.validator.addMethod("checkCAPostalCode", function(value, element) {
        var re = /^[a-zA-Z]{1}\d{1}[a-zA-Z]{1}\s{0,}\d{1}[a-zA-Z]{1}\d{1}$/;
        return !!value.match(re);
    }, "Postal Code is incorrect");

    $.validator.addMethod("checkZIP", function(value, element) {
    	var re = /^\d{5}(-\d{4})?$/;
    	return !!value.match(re);
    }, "Postal Code is incorrect");

    $.validator.addMethod("checkCAorUSAPostalCode", function(value, element) {
        var re1 = /^\d{5}(-\d{4})?$/;
        var re2 = /^[a-zA-Z]{1}\d{1}[a-zA-Z]{1}\s{0,}\d{1}[a-zA-Z]{1}\d{1}$/;
        return !!value.match(re1) || !!value.match(re2);
    }, "Postal Code is incorrect");

    $.validator.addMethod("checkAddress", function(value, element) {
        var re = /^.*(?=.{3,})(?=.*\d)(?=.*[a-zA-Z]).*$/;
        return !!value.match(re);
    }, "Address is incorrect");

    $.validator.addMethod("notEmpty", function(value, element) {
        return value !== "";
    }, "This field is required");

    // required; with placeholder, IE fix for input[type='text']
    $.validator.addMethod("requiredWP", function(value, element) {
        return $(element).val();
    }, "This field is required");

    // Non-strict check for the phone numbers
    $.validator.addMethod("phoneWeak", function(value, element) {
        value = value.trim();

        var re = /^[\d+\s+\.\(\)\-]+$/;
        return !!value.match(re) && value.length > 5;
    }, "Phone number is incorrect");
});
